var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getTolgee, getLanguageFromRequest, tolgeeModule } from '@rakutenfrance/tolgee-provider';
import { staticData } from '../translate/tolgee';
export const initialAction = (watchContext) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const promises = [];
    if (typeof window === 'undefined') {
        const language = getLanguageFromRequest(watchContext.req);
        const tolgee = getTolgee({
            language,
            staticData,
            ns: ['legal-economic-operator'],
        });
        const staticDataSSR = yield tolgee.loadRequired({ language });
        promises.push(dispatch(tolgeeModule.actions.addTolggeStaticData(staticDataSSR)));
    }
    return Promise.all(promises);
});
